"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { tv } from 'tailwind-variants';

const textAreaRecipe = tv({
  slots: {
    textarea: [
      "appearance-none w-full py-2 px-4 rounded transition-all duration-100",
      "border border-solid border-transparent bg-transparent text-black",
      "focus:outline-none",
      "placeholder:text-neutral-9",
      "disabled:text-neutral-8 disabled:placeholder:text-neutral-7"
    ]
  }
});
const textAreaWrapperRecipe = tv({
  slots: {
    wrapper: [
      "grid w-full overflow-y-hidden",
      "after:content-[attr(data-replicated-value)_'_']",
      "after:whitespace-pre-wrap after:invisible",
      "after:max-h-[var(--uikit-textarea-max-height,auto)]",
      "after:rounded after:px-4 after:py-2",
      "after:transition-all after:duration-100",
      "after:border after:border-solid after:border-transparent",
      "after:[grid-area:1/1/2/2]",
      "[&>textarea]:resize-none [&>textarea]:overflow-auto [&>textarea]:[grid-area:1/1/2/2]"
    ]
  }
});

export { textAreaRecipe, textAreaWrapperRecipe };
